import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import CloseIcon from '@material-ui/icons/Close'
import Paper from '@material-ui/core/Paper'
import { fade, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, CircularProgress }  from '@material-ui/core';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
// import DialogContentText from '@material-ui/core/DialogContentText';
import AddCircleIcon from '@material-ui/icons/AddCircle';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
// import styles from './customer.module.scss'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputMask from "react-input-mask";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const useStyles = makeStyles(theme => ({
  root: {
    width: '80%',
    margin: '20px'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  gridParent: {
    margin: '10px',
    padding: '10px',
    width: '95%',
    border: '3px solid #aaa',
    borderRadius: '20px'
  },
  gridItem: {
    padding: '5px',
    marginBottom: 5
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paymentProfiles: {
    border: '1px solid',
    // marginRight: '5px',
    // padding: '5px'
  },
  bigText: {
    fontSize: '1.5em',
    color: '#333',
    textAlign: 'center'
  },
  paddedStuff: {
    padding: '10px',
    // margin: '5px'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const filter = createFilterOptions();

const defaultState = {
  firstName: '',
  lastName: '',
  email: '',
  note: '',
  notes: '',
  companyName: '',
  receiveInvoices: true,
  receiveStatements: true,
  receiveMarketing: true,
  phoneNumbers: [
    {
      number: '',
      type: 'Primary'
    }
  ],
  category: '',
  customerContacts: [],
  builderContacts: [],
  vendorContacts: []
}

const clearContact = {
  firstName: '',
  lastName: '',
  email: '',
  notes: '',
  companyName: '',
  receiveInvoices: true,
  receiveStatements: true,
  receiveMarketing: true,
  phoneNumbers: [
    {
      number: '',
      type: 'Primary'
    }
  ]
}

const categoryOptions = [
  'Vendor Contact',
  'Builder Contact',
  'Customer Contact',
  'Internal Contact'
]

const AddNewContact = (props) => {
  // console.log('AddNewContact ', props)
  const classes = useStyles();
  const [open, setOpen] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [state, setState] = React.useState(defaultState)
  const [value, setValue] = React.useState(null)
  const [item, setItem] = React.useState({})
  const [openNewContactModal, toggleOpen] = React.useState(false)
  const [contactOptions, setContactOptions] = React.useState([])
  
  React.useEffect(() => {
    let isMounted = true
    // console.log('Get Contacts: ')
    async function getContacts() {
    // console.log('Get our CONTACTS')
      const response = await axios.get(`${props.url}/api/projects/getContacts?id=${props.project._id}&client=${props.project.client}`)
    // console.log('CONTATcS::', response.data)
      let newStateItem = {}
      if (response.data && response.data.customerContacts) newStateItem.customerContacts = response.data.customerContacts
      if (response.data && response.data.builderContacts) newStateItem.builderContacts = response.data.builderContacts
      if (response.data && response.data.vendorContacts) newStateItem.vendorContacts = response.data.vendorContacts
      // if (response && response.data && response.data.contacts) {
      //   setContacts(response.data.contacts)
      //   setRows(response.data.contacts)
      //   setFilteredRows(response.data.contacts)
      //   // setState({...state, contacts: response.data})
      //   // props.updateContacts(response.data)
      // }
      // if (response && response.data && response.data.contact) {
      //   setActiveContact(response.data.contact)
      //   // setState({...state, contacts: response.data})
      //   // props.updateContacts(response.data)
      // }
      setState({...state, ...newStateItem})
    }
    getContacts()

    return () => {
      isMounted = false
    }
  }, [])

  React.useEffect(() => {
    // console.log('Use Effect New Contact')
    // let jobName = 'Job - '
    // if (props.client.lastName) jobName = props.client.lastName + '- '
    // if (props.client.companyName) jobName = props.client.companyName + '- '
    setOpen(props.open)
    // setState({...state, jobName: jobName})
  }, [props])

const handleClose = () => {
  // console.log('Closing New Contact Modal')
  // setOpen(false)
  setState(defaultState)
  props.closeModal('Close')
}

const handleConfirm = (data) => {
  // console.log('CONFIRMED NEW JOB!!', data)
}

const handleSave = () => {
  // setLoading(true)
// console.log('handle save new contact', state)
// console.log(props)
  // // let obj = {
  // //   project: props,                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        : props.project,
  // //   contact: state
  // // }
  let obj = {
    id: props.project._id,
    contact: state
  }
  axios({
    method: 'post',
    url:  `${props.url}/api/projects/createNewContact`,
    data: obj,
    // validateStatus: (status) => {
    //   // console.log('Validate status: ', status)
    //   if (status && status === 500) {

    //   }
    // },
  }).then(response => {
    // console.log('Axios response to create new Contact: ', response)
    setLoading(false)
    // setJobNumber(response.data)
    if (response.data._id) {
      // props.newNoteResponse('newNote', response.data)
      
      // setState({note: ''})
      props.notification({
        type: 'success',
        title: 'New Contact Saved!',
        message: 'Well Done!!'
      })
      // setOpen(false)
      setState(defaultState)
      props.saveContact(response.data)
    } else {
      // console.log()
      props.notification({
        type: 'warning',
        title: 'Uh Oh!',
        message: 'Something messed up creating this contact...not sure why!'
      })
    }
    
  }).catch(err => {
  // console.log('Error saving new contact: ', err)
  })
}

const handlePhoneNumberChange = (e, phone, index) => {
  // console.log('Handle Phone Number Change: ', phone)
  // console.log(index)
  // console.log(e.target.value)
  let newPhoneNumbers = [...state.phoneNumbers]
  newPhoneNumbers[index] = {
    number: e.target.value,
    type: phone.type
  }
  // console.log('new Phone Numbers: ', newPhoneNumbers)
  setState({...state, phoneNumbers: newPhoneNumbers})
}

const addPhoneNumber = () => {
  let newPhoneNumbers = [...state.phoneNumbers]
  newPhoneNumbers.push({
    number: '',
    type: 'Primary'
  })
  setState({...state, phoneNumbers: newPhoneNumbers})
}

const removePhoneNumber = (index) => {
  if (state.phoneNumbers.length > 1) {
    if (window.confirm('Are you sure you wish to delete this phone number? This is not reversible.')) {
      let newPhoneNumbers = [...state.phoneNumbers]
      newPhoneNumbers.splice(index, 1)
      setState({...state, phoneNumbers: newPhoneNumbers})
    }
  }
}

const changePhoneType = (e, phone, index) => {
  // console.log('Phone Type Change: ', phone)
  // console.log(e.target.value)
  let updatedNumbers = state.phoneNumbers
  updatedNumbers[index]['type'] = e.target.value
  setState({...state, phoneNumbers: updatedNumbers})
}

const handleChooseCategory = (e) => {
// console.log("Choose", e.target.value)
  setValue(null)
  setItem(null)
  let chosen = e.target.value
  if (chosen === 'Vendor Contact') {
    setContactOptions(state.vendorContacts)
  }
  if (chosen === 'Builder Contact') {
    setContactOptions(state.builderContacts)
  }
  if (chosen === 'Customer Contact') {
    setContactOptions(state.customerContacts)
  }
  if (chosen === 'Internal Contact') {
    setContactOptions(props.employees)
  }
  let t = {...clearContact}
// console.log('Category to set', e.target.value)
// console.log('T: ', t)
  setState({...state, category: e.target.value, ...clearContact })
}

const [dialogValue, setDialogValue] = React.useState({
  title: '',
  year: '',
});

const chooseContact = (newValue) => {
  if (newValue && newValue.phoneNumbers.length < 1) {
    let newPhoneNumbers = [{
      number: '',
      type: 'Primary'
    }]
    newValue.phoneNumbers = newPhoneNumbers
  }
  setItem(newValue)
  setState({...state, ...newValue})
}

return (
  <div className={classes.root}>
    <Dialog open={open} fullWidth={true} onClose={handleClose} maxWidth='md' aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add New Contact to the Project</DialogTitle>
        <DialogContent >
        <IconButton onClick={handleClose} style={{ 'position': 'absolute', 'top': '15px', 'right': '30px' }} edge='end' alt="Close" aria-label="Close">
          <CloseIcon />
        </IconButton>
          <DialogContentText>
            Please Add The Contact Details Below
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item lg={12}>
              <h3>Contact Type</h3>
            </Grid>
            <Grid item lg={12} md={12} xs={12} className={classes.gridItem}>
              <FormControl
                variant="outlined"
                fullWidth
                >
                  <InputLabel>Contact Type</InputLabel>
                  <Select
                    labelId="contact-type-label"
                    id="contact-type-simple-select-outlined"
                    value={state.category}
                    label="Contact Type"
                    inputProps={{ 'aria-label': 'Contact Type' }}
                    variant="outlined"
                    onChange={handleChooseCategory}
                  >
                    {
                      categoryOptions.map(unit => {
                        return (
                        <MenuItem key={unit} value={unit} >{unit}</MenuItem>
                      )})
                    }
                  </Select>
                </FormControl>
              </Grid>
            <Grid item lg={12}>
              {
                state.category ? (
                  <Autocomplete
              freeSolo
              limitTags={5}
              id={`description-input`}
              // value={state.description}
              options={contactOptions}
              value={value}
              // getOptionLabel={(option) => option.name}
              getOptionLabel={(option) => {
                // console.log('Get Option label', option)
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return 'Save ' + option.inputValue + ' as a New Contact';
                }
                const chosen = state.category
                const vendorName = option.vendor ? option.vendor.name : ''
                const companyName = option.client ? option.client.searchName : ''
                if (chosen === 'Vendor Contact') {
                  return option.firstName + ' ' + option.lastName + ' - ' + vendorName;
                }
                if (chosen === 'Builder Contact') {
                  return option.firstName + ' ' + option.lastName + ' - ' + companyName;
                }
                if (chosen === 'Customer Contact') {
                  return option.firstName + ' ' + option.lastName + ' ' + option.notes || ''
                }
                if (chosen === 'Internal Contact') {
                  return `${option.firstName} ${option.lastName} ${option.type ? `  -  ${option.type}` : ''}`;
                }
                // Regular option
                // return option.firstName + ' ' + option.lastName + ' - ' + option.companyName;
              }}
              // style={{ width: 200 }}
              // onChange={handleDescriptionChange}
              onChange={(event, newValue) => {
              // console.log('Change in value:', newValue)
                event.preventDefault()
                if (newValue && newValue._id) {
                  // console.log('AN Active object was selected')
                  // chooseContact(newValue)
                } else {
                // console.log('Why?? 454')
                  // setItem({
                  //   title: newValue,
                  //   name: newValue
                  // })
                  // toggleOpen(true);
                }
                if (typeof newValue === 'string') {
                // console.log('huh? 462')
                  setValue({
                    title: newValue,
                    name: newValue
                  });
                  // setItem({
                  //   title: newValue,
                  //   name: newValue
                  // })
                } else if (newValue && newValue.inputValue) {
                // console.log('Set New Item', newValue.inputValue)
                  // Create a new value from the user input
                  let name = newValue.inputValue.split(' ')
                  let firstName = name[0]
                  let lastName = ''
                  if (name && name.length > 1) lastName = name[1]
                  // setValue({
                  //   title: newValue.inputValue,
                  //   name: newValue.inputValue
                  // });
                  setItem({
                    title: newValue.inputValue,
                    firstName: newValue.inputValue,
                    lastName: newValue.inputValue,
                    description: newValue.inputValue,
                    _id: 'new'
                  })
                  // toggleOpen(true);
                  // setDialogValue({
                  //   title: newValue.inputValue,
                  //   year: '',
                  // });
                  setState({...state, firstName: firstName, lastName: lastName })
                } else {
                // console.log('NEWV AL: ', newValue)
                  setValue(newValue);
                  newValue.category = state.category
                  chooseContact(newValue)
                
                }
              }}
              filterOptions={(options, params) => {
                // console.log('Filtered Options', options)
                // console.log('Params', params)
                // console.log('Input value: ', params.inputValue)
                const filtered = filter(options, params);
        
                // Suggest the creation of a new value
                if (params.inputValue !== '') {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Add "${params.inputValue}"`,
                    name: 'Test This'
                  });
                }
        
                return filtered;
              }}
              selectOnFocus
              clearOnBlur
              handleHomeEndKeys
              // onChange={ (e) => updateCrew(service, e.target.id, e.target.value, serviceIndex) }
              // value={state.activeLineItem}
              fullWidth
              // InputProps={{ style: { fontSize: 20, color: '#fff', backgroundColor: '#333' } }}
              PaperComponent={({ children }) => (
                <Paper style={{ padding: 5, fontSize: 20, color: '#bbb', backgroundColor: '#fff' }}>{children}</Paper>
              )}
              // onChange={ e => setState({...state, serviceType: e.target.value, requiresUpdate: true }) }
              renderInput={(params) => <TextField {...params}  fullWidth label="Search Database for Contacts" variant="outlined" />}
            />
                ) : null
              }
            
            </Grid>
            {
              (item && item._id) ? (
                <>
                 <Grid item lg={12}>
                  <h3>Contact Information</h3>
                </Grid>
                <Grid item lg={6} xs={6} className={classes.gridItem}> 
                  <TextField
                    
                    label="Contact First Name"
                    onChange={ e => setState({...state, firstName: e.target.value })}
                    name="customerfirstname"
                    value={ state.firstName }
                    margin="normal"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={6} xs={6} className={classes.gridItem}> 
                            
                  <TextField
                  
                    label="Contact Last Name"
                    onChange={ e => setState({...state, lastName: e.target.value })}
                    name="customerlastname"
                    value={ state.lastName }
                    margin="normal"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={12} xs={12} className={classes.gridItem}> 
                  <TextField
                      
                      margin="dense"
                      id="Email"
                      label="Email"
                      type="text"
                      onChange={(e) => setState({...state, email: e.target.value})}
                      value={state.email}
                      fullWidth
                  />
                
                </Grid>
                  { state.phoneNumbers.map((phone, index) => (
                    <React.Fragment key={index}>
                    <Grid item lg={5} xs={5} className={classes.gridItem}> 
                    <InputMask mask="(999) 999-9999" maskPlaceholder=" " onChange={e => handlePhoneNumberChange(e, phone, index)}  value={phone.number} >
                        {
                          () => {
                            return (
                                <TextField
                                margin="dense"
                                id="Telephone"
                                label={"Telephone Number #" + (index - 0 + 1)}
                                type="telephone"
                                // onChange={(e) => handlePhoneNumberChange(e, phone, index)}
                                // value={state.phoneNumbers[index]['number']}
                                // value={phone.number}
                                fullWidth
                            />
                            )
                          }
                        } 
                          </InputMask>
                          </Grid>
                          <Grid item lg={4} xs={4}>
                          <FormControl className={classes.formControl} fullWidth>
                            <Select
                              value={phone.type}
                              onChange={(e) => changePhoneType(e, phone, index)}
                              // onChange={(e) => setState({...state, phone['type']: e.target.value })}
                              className={classes.selectEmpty}
                              inputProps={{ 'aria-label': 'Phone Number Type' }}
                              fullWidth
                              placeholder="Phone Number Type"
                            >
                              <MenuItem value={"Primary"}>
                                Primary
                              </MenuItem>
                              <MenuItem value={"Home"}>Home</MenuItem>
                              <MenuItem value={"Mobile"}>Mobile</MenuItem>
                              <MenuItem value={"Work"}>Work</MenuItem>
                            </Select>
                            <FormHelperText>Phone Number Type</FormHelperText>
                          </FormControl>
                          </Grid>
                          <Grid item lg={2} xs={2} style={{
                              display: 'flex',
                              marginLeft: '50px',
                              alignItems: 'center',
                              flexWrap: 'wrap'
                          }}>
                          <IconButton edge='start' alt="Remove" aria-label="Remove" onClick={removePhoneNumber}>
                              <RemoveCircleIcon />
                            </IconButton>
                            { index === state.phoneNumbers.length - 1 ?  <IconButton edge='end' alt="Add" aria-label="Add" onClick={addPhoneNumber}>
                              <AddCircleIcon />
                            </IconButton> : ''}
                          </Grid>
                    </React.Fragment>
                  ))}
          
              
              <Grid item lg={12} md={12} xs={12} className={classes.gridItem}>
                  <TextField
                    
                  
                    variant="outlined"
                    id="Note"
                    label="Contact Notes"
                    multiline
                    rows={4}
                    type="text"
                    onChange={(e) => setState({...state, notes: e.target.value})}
                    value={state.notes}
                    fullWidth
                    InputLabelProps={{ shrink: state.notes ? true : false }}
                  />
              </Grid>
            </>
            ) : null
          }
        </Grid>
          
          

        </DialogContent>
        <DialogActions>
          {/* <Button onClick={() => setState({...state, editJobName: false})} color="primary">
            Cancel
          </Button> */}
          <Button color="primary" disabled={loading || !state.firstName || !state.category } onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
  </div>
  )
  }


  const mapStateToProps = (state) => {
    return {
      url: state.url,
      user: state.user,
      notification: state.notification,
      employees: state.employees
    }
  }
  
  export default React.memo(connect(mapStateToProps)(AddNewContact))